import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

const ShowMoreList = ({
  data = [],
  initialShow = 1,
  visible = false,
  defaultReturn = "-",
  className,
  showMoreTrans,
  showLessTrans
}) => {
  const [isVisible, setIsVisible] = useState(visible);
  const { t } = useTranslation();

  const toggleVisible = () => setIsVisible(!isVisible);

  return (
    <div className={classNames("show-more-list", className)}>
      {data.length === 0 && defaultReturn}
      {data.map((item, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className={idx < initialShow || isVisible ? "item active" : "item"} key={idx}>
          {item}
        </div>
      ))}
      {initialShow < data.length && (
        <button
          type="button"
          onClick={toggleVisible}
          className="show-more-list-trigger"
          style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
        >
          {isVisible ? (
            <span>
              <i className="ti-angle-up mr-5" />
              {t(showLessTrans || "container.general_words.hide")}
            </span>
          ) : (
            <span>
              <i className="ti-angle-down mr-5" />
              {t(showMoreTrans || "container.general_words.show_more")}
            </span>
          )}
        </button>
      )}
    </div>
  );
};

export default ShowMoreList;
